import { createContext } from 'react';
import { BillingMetrics } from '../../shared/BillingMetrics';

export interface AdvancedDailyEngagedUsersContextProps {
  dateToSearch: Date;
  setDateToSearch: (date: Date) => void;
  periodOptions: any;
  currentMonth: boolean;
  tenant: any;
  loggedUser: any;
  content: any; 
  billingAdvancedDailyEngagedUserApi: any;
  trackingProps: any;
  getPlanStatus: () => Promise<any>;
  isMetricAllowed: (metric: BillingMetrics) => boolean;
}

const AdvancedDailyEngagedUsersContext = createContext<AdvancedDailyEngagedUsersContextProps>(
  {} as AdvancedDailyEngagedUsersContextProps,
);

export default AdvancedDailyEngagedUsersContext;